import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import {
  ButtonModule, OnChange, SpinnerModule, TextAreaComponentModule,
} from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { ActionCreator, ActionsSubject } from '@ngrx/store';
import { tap } from 'rxjs';
import { ofType } from '@ngrx/effects';

import { PatchPersonalInfoReq } from './models';

@Component({
  selector: 'pu-user-hobby',
  imports: [
    TranslateModule,
    ButtonModule,
    ReactiveFormsModule,
    TextAreaComponentModule,
    SpinnerModule,
  ],
  templateUrl: './user-hobby.component.html',
  styleUrls: ['./user-hobby.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserHobbyComponent {
  @Input() @OnChange('userHobbyChanged') hobby: string;
  @Input() @OnChange('saveSucceededActionChanged') saveSucceededAction: ActionCreator;
  hobbyChanged = output<PatchPersonalInfoReq>();

  readonly destroyRef = inject(DestroyRef);

  private _fb = inject(FormBuilder);
  private _actionsSubject = inject(ActionsSubject);
  private _cdr = inject(ChangeDetectorRef);

  editMode = false;

  form = this._fb.group({
    hobby: ['', [Validators.maxLength(200)]],
  });

  applyChanges() {
    this.hobbyChanged.emit(this.form.value);
  }

  cancel() {
    this.editMode = false;
    this.form.setValue({
      hobby: this.hobby || '',
    });
  }

  saveSucceededActionChanged(value: ActionCreator) {
    if (value) {
      this._actionsSubject
        .pipe(
          ofType(value),
          tap(() => {
            this.editMode = false;
            this._cdr.detectChanges();
          }),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe();
    }
  }

  userHobbyChanged(value: string) {
    this.form.setValue({
      hobby: value ? value : '',
    });
  }
}
